import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaintenanceWindowComponent } from 'src/shared/components/maintenance-window/maintenance-window.component';
import { DarkModeService } from 'src/shared/services/darkmode/darkmode_service';
import { initTranslations } from 'src/shared/translate/custom.translate.loader';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './trials.component.html',
  styleUrl: './trials.component.scss',
  imports: [RouterOutlet, MaintenanceWindowComponent],
  // host: {
  //   '[attr.data-theme]': 'theme()',
  // },
})
export class TrialsComponent {
  darkModeService: DarkModeService = inject(DarkModeService);
  theme = computed(() => (this.darkModeService.darkModeOn() ? 'dark' : 'light'));
  constructor() {
    // Initialize translations
    initTranslations();
    if (environment.production) {
      // Add any production-specific initialization here
    }
  }
}
